import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';

import { TOOLTIPS_TEXTS } from './tooltips';

const homePhotosTableTooltips = TOOLTIPS_TEXTS.homeGalleryTable;

export const BASE_HOME_PHOTOS_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'download', src: 'icons/download-green' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_HOME_PHOTOS_TABLE_CONFIG: TableSource = {
  displayedColumns: ['checkbox', 'index', 'image', 'options'],
  displayedTitles: ['All', 'Order', 'Thumbnail', 'Actions'],
  columnsConfig: [{ sorting: false }, { sorting: false }, { sorting: false }, { sorting: false }],
  displayedTooltips: ['', homePhotosTableTooltips.order, '', ''],
  options: null,
  dataSource: []
};
